// AB ADDED
import { rankWith, uiTypeIs } from '@jsonforms/core';
import { withJsonFormsLayoutProps } from '@jsonforms/react';
import SeverityMessage from './SeverityMessage';

const isLabel = uiTypeIs('Label');

const CustomLabel = ({ uischema }) => {
  const { text, options = {} } = uischema;
  const severity = options.severity;
  const className = options.classNames || '';

  if (severity) {
    return (
      <SeverityMessage severity={severity} className={className}>
        {text}
      </SeverityMessage>
    );
  }

  return <div className={className}>{text}</div>;
};

export const CustomLabelRenderer = {
  tester: rankWith(4, isLabel),
  renderer: withJsonFormsLayoutProps(CustomLabel)
};
